import {
  MEMBER_SUBSCRIPTION_EXPIRED_CHECK,
  CHNAGE_PASSWORD,
  RESET_PASSWORD,
  FORGOT_PASSWORD,
  OTP_VERIFY,
  SET_PASSWORD,
  FCMTOKEN,
  USER_ACTIVATE_URL,
  USER_LOGIN_URL,
  USER_LOGOUT_URL,
  USER_PROFILE_VISIBLITY_URL,
  UPDATE_USER_LOCATION,
  USER_SUB_DETAIL,
  GET_SYSTEM_SETTINGS,
  UPDATE_SYSTEM_SETTINGS,
  UPDATE_USER_ON_MOBIMYTRAVEL,
  GENERATE_LL_URL,
  LOCATION_LIST,
} from "../api";
import axiosInstance from "../axiosInstance";

export const userLogin = (props) => (onResponse) => {
  try {
    let BASE_URL = USER_LOGIN_URL + "?web=" + true;
    axiosInstance
      .post(BASE_URL, props.formData)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) { }
};
export const userLogout = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(USER_LOGOUT_URL, props.formData)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) { }
};

export const UserActivate = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(USER_ACTIVATE_URL, props.formData)
      .then((res) => {
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

export const locationList = (props) => (onResponse) => {
  let BASE_URL = `${LOCATION_LIST}?`;
  if (props?.page) {
    BASE_URL += `page=${props?.page}&`;
  }
  if (props?.limit) {
    BASE_URL += `limit=${props?.limit}&`;
  }

  try {
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err?.response?.data);
      });
  } catch (error) { }
};

export const updateFCM = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(FCMTOKEN, props)
      .then((response) => {
        onResponse(response.data);
      })
      .catch((err) => { });
  } catch (err) { }
};
export const UserProfileVisiblity = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(USER_PROFILE_VISIBLITY_URL, props)
      .then((res) => {
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

export const passwordReset = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(RESET_PASSWORD, props.values)
      .then((res) => {
        console.log(res);

        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

export const passwordChnage = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CHNAGE_PASSWORD, props.values)
      .then((res) => {
        console.log(props);
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

export const resetPassword = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(FORGOT_PASSWORD, props.values)
      .then((res) => {
        console.log(props);
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};
export const updateUserLocation = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(UPDATE_USER_LOCATION, props)
      .then((res) => {
        console.log(props);
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

export const userpassword = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(SET_PASSWORD, props.values)
      .then((res) => {
        console.log(props);
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

export const verifyotp = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(OTP_VERIFY, props.values)
      .then((res) => {
        console.log(props);
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};
export const getUserSubDetails = (props) => (onResponse) => {
  try {
    let url = USER_SUB_DETAIL;
    if (props) {
      const params = Object.keys(props)
        .filter((key) => props[key] !== undefined && props[key] !== null)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(props[key])}`)
        .join("&");
      if (params) {
        url += `?${params}`;
      }
    }
    axiosInstance
      .get(url)
      .then((res) => {
        console.log(props);
        if (res?.data?.status && res?.data?.data) {
          localStorage.setItem("userinfo", JSON.stringify(res.data.data));
        }
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

export const checkMemberSubscriptionExpired = () => (onResponse) => {
  try {
    axiosInstance
      .post(MEMBER_SUBSCRIPTION_EXPIRED_CHECK)
      .then((res) => {
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {
    onResponse(undefined);
  }
};

export const getSystemSetings = (props) => (onResponse) => {
  try {
    axiosInstance
      .get(GET_SYSTEM_SETTINGS)
      .then((res) => {
        console.log(props);
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};
export const updateSystemSetings = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(UPDATE_SYSTEM_SETTINGS, props)
      .then((res) => {
        console.log(props);
        onResponse(res?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) { }
};

// mobimytravel sso

export const updateUserOnMobimyTravel = async (props) => {
  try {
    const response = await axiosInstance.post(
      UPDATE_USER_ON_MOBIMYTRAVEL,
      props
    );
    return response?.data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
};

export const generateLLUrl = async () => {
  try {
    const response = await axiosInstance.post(GENERATE_LL_URL);
    return response?.data;
  } catch (error) {
    console.log(error, "LL_ERROR");
    throw error?.response?.data;
  }
};
